<template>
  <ul v-if="articles.length" class="article-bullet-list__wrapper">
    <li
      v-for="article in articles"
      :key="article.id"
      class="article-bullet-list__list-item"
    >
      <a-link
        :to="article.canonicalUrl"
        class="article-bullet-list__article-title"
        >{{ article.title }}</a-link
      >
      <time v-if="showTimestamp" class="article-bullet-list__timestamp">
        {{ $helper.formatDate.toDefault(article.publishedOn) }}
      </time>
    </li>
  </ul>
</template>

<script>
import { PROP_TYPES, propValidator } from '@/utils/validators'

export default {
  name: 'ArticleBulletList',
  props: {
    articles: propValidator([PROP_TYPES.ARRAY]),
    showTimestamp: propValidator([PROP_TYPES.BOOLEAN], false, false)
  }
}
</script>

<style scoped lang="scss">
@import '~assets/scss/global/mixins/figures';
@import '~assets/scss/local/styles/article';

.article-bullet-list__wrapper {
  .article-bullet-list__list-item {
    font-size: 18px;

    @include bullet($line-height: 22px);

    margin-bottom: 20px;

    &:last-child {
      margin-bottom: 0;
    }
  }

  .article-bullet-list__article-title {
    display: block;
    max-width: fit-content;
  }

  .article-bullet-list__timestamp {
    display: block;
    @extend .timestamp;
  }
}
</style>
